import { actions, effects, feature } from './lib/+state/scoped-palette.feature';

export {
  ScopedPaletteApplyTarget,
  ScopedPaletteDirective,
  ScopedPaletteResolveMode,
} from './lib/directives/scoped-palette.directive';
export {
  SCOPED_PALETTE_INCLUDE_CHILDREN_KEY,
  SCOPED_PALETTE_INCLUDE_LEARNING_DOMAINS_KEY,
  SCOPED_PALETTE_INCLUDE_TOC_ANCESTORS_KEY,
  resolveScopedPalette,
} from './lib/resolvers/scoped-palette.resolver';
export type { ScopedPaletteState } from './lib/+state/scoped-palette.feature';

// Curated namespace re-export. Only the three handles consumers actually need
// — `feature` (StoreModule.forFeature + selectors), `effects`
// (EffectsModule.forFeature), and `actions` (dispatching from non-directive
// code). Helpers like `responseToEntries`, `mergeEntries`, `apiCall`, the
// individual effect references and `initialState` stay lib-internal.
export const ScopedPaletteFeature = { actions, effects, feature } as const;
